module.exports = __webpack_public_path__ + "e682e10fb4d86a6bd4681e20662db1d3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-princess.png
// module id = 2893
// module chunks = 0